module.exports = __webpack_public_path__ + "img/icon_card013.f1016379.png";